// constants
import { apiRouter } from "@cloudspire/legacy-shared/src/constants/router";

// libraries
import { request, encodeQuery } from "@cloudspire/legacy-shared/src/libraries";

type RoomAvailabilitiesFindByReferenceType = {
  requestContext;
  parameters: {
    reference: string;
  };
  query: {
    from: string;
    to: string;
    channelId: string;
    checkin?: string;
  };
};

/**
 * Cherche les disponibilités d'un hébergement par sa référence.
 */
const roomAvailabilitiesFindByReference = ({
  requestContext,
  parameters,
  query,
}: RoomAvailabilitiesFindByReferenceType) => {
  const route = apiRouter
    .findByName("Api.Alfred.RoomsAvailabilities.ListLegacy")
    .toFilled();
  route.setParameters(parameters);

  return request({
    url: route.generateUri().withQuery(encodeQuery(query)).toString(),
    method: route.getMethods()[0],
    context: requestContext,
  });
};

export default roomAvailabilitiesFindByReference;
